




















import Vue from "vue";
import InfoBox from "@/lib/components/InfoBox.vue";
import {
  alertMessage,
  qsParams,
  setHighestPriorityCustomerApplication,
} from "@/lib/utilities";
import { isEmpty } from "../../utilities";
import ItemDescriptions from "@/lib/partials/shared/ItemDescriptions.vue";
import { AgreementDto } from "@/lib/api/APIService";
import { OverallStatusNames } from "@/lib/utilities/overallStatusNames";
import { shouldShowSubagreement } from "@/lib/agreementUtilities";

interface Data {
  id: string;
  documentId: string;
  tender: AgreementDto | null;
  infoDescription: string;
  agreementType: string;
}

export const SECONDARY_DESCRIPTIONS = [
  {
    title: 'Leverandører',
    key: 'supplierList',
    componentName: 'suppliers',
    fields: [
      { key: 'role', label: 'Rolle', thClass: 'pl-0', tdClass: 'pl-0' },
      { key: 'name', label: 'Navn' },
      { key: 'jobTitle', label: 'Titel' },
      { key: 'phone', label: 'Tlf. nr.' },
      { key: 'email', label: 'E-mail' }
    ]
  },
  {
    title: 'Vejledninger for kunder',
    key: 'document',
    componentName: 'agreementDocuments',
  },
  {
    title: 'Vejledninger for leverandører',
    key: 'document',
    componentName: 'agreementDocuments',
  },
  {
    title: 'Aftaledokumenter',
    key: 'document',
    componentName: 'agreementDocuments',
  },
  {
    title: 'Ekspertgruppe',
    key: 'projectGroup',
    componentName: 'expertGroup',
    fields: [
      {
        key: 'customerName',
        label: 'Organisation',
        thClass: 'pl-0',
        tdClass: 'pl-0',
      },
      { key: 'shoppingCommunity[0].name', label: 'Indkøbsfællesskab' },
    ],
  },
];

export default Vue.extend({
  components: { InfoBox, ItemDescriptions },
  props: {
    descriptionsTitle: {
      type: String,
      default: ''
    },
    descriptionsDescription: {
      type: String,
      default: ''
    }
  },
  data(): Data & { SECONDARY_DESCRIPTIONS: any[] } {
    return {
      id: "",
      documentId: "",
      tender: null,
      infoDescription: "",
      agreementType: "",
      SECONDARY_DESCRIPTIONS
    };
  },
  created() {
    this.id = qsParams().id;
    this.documentId = qsParams().documentId;
    this.fetchAndSetAgreementAPIData();
  },
  methods: {
    async fetchAndSetAgreementAPIData() {
      try {
        const tenderResponse: AgreementDto = await this.$api.AgreementsRepository.get(this.id);
        const agreementDescriptions =
          await this.$api.AgreementsRepository.getDescription(this.id);
        this.$root.$data.itemDescriptions = agreementDescriptions;
        if (this.redirectToAgreementPage(tenderResponse)) return;

        if (tenderResponse) {
          if (this.$store.getters.isLoggedIn) {
            setHighestPriorityCustomerApplication(this, tenderResponse);
          } else {
            tenderResponse[this.$config.agreement.application.activeApplication] = null;
          }
        }

        var infoDescriptionRaw = agreementDescriptions.find(
          (x: { agreementDescriptionName: string }) =>
            x.agreementDescriptionName === "Særlig information om aftalen"
        );
        this.infoDescription =
          infoDescriptionRaw !== undefined
            ? infoDescriptionRaw.agreementDescriptionText
            : "";

        this.tender = tenderResponse;
        this.$root.$data.item = this.tender;
        this.setAgreementType(this.tender);
      } catch (err) {
        alertMessage(this);
      }
    },
    setAgreementType(tender: AgreementDto) {
      if (tender === null) return;
      // TODO: FIX This should be handled by backend API
      if (tender.mainAgreementName) {
        this.$root.$data.agreementType = this.agreementType = "subAgreement";
      } else if (!isEmpty(tender.subAgreement)) {
        this.$root.$data.agreementType = this.agreementType =
          "mainAgreementWithSubAgreements";
      } else {
        this.$root.$data.agreementType = this.agreementType = "mainAgreement";
      }
    },
    redirectToAgreementPage(tender: AgreementDto): boolean {
      if (tender.overallStatusName !== OverallStatusNames.Upcoming) {
        window.location.href = `/aftaler/se-aftale/?id=${this.id}${
          this.documentId !== undefined ? "&documentId=" + this.documentId : ""
        }`;
        return true;
      }
      return false;
    },
  },
  computed: {
    doesNotHaveVisibleSubagreements(): boolean {
      if (this.tender && this.tender.subAgreement) {
        // Only show status if there are no visible subagreements
        // Statusupdates are tracked at subagreement level when visible
        const visibleSubAgreements = this.tender.subAgreement.filter(sub => shouldShowSubagreement(sub));
        return visibleSubAgreements.length === 0;
      }
      return true;
    }
  },
});
